import { supabase } from '@/integrations/supabase/client'
import { Caregiver } from '@/lib/services/caregiver-service'
import { logger } from '@/lib/services/logger-service'
import { Database } from '@/types/supabase'

export class CaregiverRepository {
  static async getByAuthId(authUserId: string): Promise<Caregiver | null> {
    try {
      const { data, error } = await supabase
        .from('caregivers')
        .select('*')
        .eq('auth_user_id', authUserId)
        .maybeSingle()

      if (error) {
        logger.error('Error fetching caregiver:', error)
        return null
      }

      return data
    } catch (error) {
      logger.error('Unexpected error in getByAuthId:', error)
      return null
    }
  }

  static async updateLastActivity(caregiverId: string, activityType?: string): Promise<void> {
    try {
      const { error } = await supabase.rpc('update_caregiver_activity', {
        p_caregiver_id: caregiverId,
        p_activity_type: activityType
      })

      if (error) {
        logger.error('Error updating caregiver activity:', error)
        throw error
      }
    } catch (error) {
      logger.error('Unexpected error in updateLastActivity:', error)
      throw error
    }
  }

  static async deleteCaregiver(caregiverId: string): Promise<boolean> {
    try {
      const { data, error } = await supabase
        .rpc('delete_caregiver', {
          p_caregiver_id: caregiverId
        })

      if (error) {
        logger.error('Error deleting caregiver:', error)
        throw error
      }

      return true
    } catch (error) {
      logger.error('Unexpected error in deleteCaregiver:', error)
      throw error
    }
  }

  static async getCaregiverProfileData(caregiverId: string): Promise<Database['public']['CompositeTypes']['caregiver_profile_type'][]> {
    try {
      const { data, error } = await supabase
        .rpc('getcaregiverprofiledatav2', {
          p_caregiver_id: caregiverId
        })

      if (error) {
        logger.error('Error fetching caregiver profile data:', error)
        throw error
      }

      return data || []
    } catch (error) {
      logger.error('Unexpected error in getCaregiverProfileData:', error)
      throw error
    }
  }
}
